import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight, FiBookOpen } = FiIcons;

function HomeScreen({ onStart, onShowAbout }) {
  return (
    <motion.div 
      className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-brand-sage/20 p-8 mb-6"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="text-center mb-8">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="inline-block p-4 rounded-full bg-gradient-to-br from-brand-teal to-brand-dark-blue mb-6"
        >
          <SafeIcon icon={FiBookOpen} className="h-12 w-12 text-white" />
        </motion.div>
        
        <motion.h2 
          className="text-4xl font-abril text-brand-dark-blue mb-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          Reading Phase Screener
        </motion.h2>
        
        <motion.p 
          className="text-lg text-gray-700 mb-8 leading-relaxed max-w-2xl mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          Identify which of Ehri's reading phases your student is in with this quick 5-minute assessment.
        </motion.p>
        
        <motion.button 
          onClick={onStart}
          className="bg-gradient-to-r from-brand-teal to-brand-dark-blue hover:from-brand-teal-dark hover:to-brand-dark-blue text-white font-semibold py-4 px-8 rounded-full shadow-lg transition-all duration-300 text-lg flex items-center gap-2 mx-auto hover:shadow-xl hover:scale-105 focus:outline-none focus:ring-4 focus:ring-brand-teal/30"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.98 }}
        >
          Start Screener
          <SafeIcon icon={FiArrowRight} className="h-5 w-5" />
        </motion.button>
      </div>
      
      <motion.div 
        className="border-t border-brand-sage/30 pt-6 mt-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.5 }}
      >
        <h3 className="text-xl font-abril text-brand-dark-blue mb-3">About Ehri's Phases</h3>
        <p className="text-gray-700 mb-4 leading-relaxed">
          Ehri's phases describe how children develop as readers, from recognizing environmental print to becoming fluent readers.
        </p>
        <button 
          onClick={onShowAbout}
          className="text-brand-teal hover:text-brand-teal-dark font-semibold inline-flex items-center gap-1 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 rounded-md px-2 py-1"
        >
          Learn more
          <SafeIcon icon={FiArrowRight} className="h-4 w-4" />
        </button>
      </motion.div>
    </motion.div>
  );
}

export default HomeScreen;